var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:['v-status-badget', _vm.statusClass]},[_vm._v(" "+_vm._s(_vm.statusTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }